//@flow
import React, {useState} from 'react';
import {
  Grid,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
} from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import {Check, Star, ArrowForwardIos} from '@material-ui/icons';

import {colors} from '../../assets/styles/colors';

import ContentItem from './ContentItem';

import type {Props as Content} from './ContentItem';
import GradientButton from '../GradientButton/GradientButton';
import CustomButton from '../CustomButton/CustomButton';

type Props = {
  title: string,
  benefits: string[],
  content: Content[] | Content,
  onClick?: () => void,
};

const useStyles = props =>
  makeStyles(theme => ({
    root: {
      background: '#F8F9FB',
      height: '100%',
      [theme.breakpoints.up('md')]: {
        background: 'white',
      },
    },
    benefit: {
      padding: 32,
      paddingBottom: 8,
      height: 'auto',
      [theme.breakpoints.up('sm')]: {
        padding: 32,
      },
      [theme.breakpoints.up('md')]: {
        height: '100%',
        paddingTop: 60,
      },
    },
    title: {
      color: colors.white,
      fontWeight: 600,
      fontSize: 27,
      [theme.breakpoints.up('sm')]: {
        fontSize: 32,
      },
      [theme.breakpoints.up('md')]: {
        fontSize: 36,
      },
      [theme.breakpoints.up('lg')]: {
        fontSize: 40,
      },
    },
    item: {
      paddingLeft: 0,
    },
    itemIcon: {
      minWidth: 30,
      color: colors.purple,
    },
    content: {
      padding: 32,
      height: '70%',
      background: props.contentBg,
      borderRadius: '40px 40px 0 0',

      [theme.breakpoints.up('md')]: {
        borderRadius: '40px 0 0 40px',
        height: '100%',
        paddingTop: 60,
      },
    },
    footer: {
      display: 'flex',
      justifyContent: 'flex-end',
      position: 'relative',
      alignItems: 'center',
      marginTop: 24,
    },
    nextContent: {
      background: '#FFFFFF66',
      color: 'white',
      position: 'absolute',
      bottom: 80,
      right: -16,
      [theme.breakpoints.up('sm')]: {
        position: 'relative',
        bottom: 'initial',
      },
    },
    btn: {
      width: '100%',
      maxWidth: 400,
      marginRight: 'auto',
    },
    btnLabel: {
      fontSize: 16,
      fontWeight: 600,
      color: 'white',
      [theme.breakpoints.up('sm')]: {
        fontSize: 18,
      },
      [theme.breakpoints.up('md')]: {
        fontSize: 20,
      },
    },
  }));

export default function ProplusUpgradeBanner(props: Props) {
  const {title, benefits, content, onClick} = props;
  const [contentIndex, setContentIndex] = useState(0);

  const {contentBg} = Array.isArray(content) ? content[contentIndex] : content;

  const classes = useStyles({contentBg: contentBg || colors.darkPurple})();

  const changeContentIndex = () => {
    if (!Array.isArray(content)) return;

    const newIndex = contentIndex + 1;

    if (newIndex < content.length) {
      return setContentIndex(newIndex);
    }
    setContentIndex(0);
  };

  return (
    <Grid container className={classes.root} onClick={onClick}>
      <Grid xs={12} md={4} className={classes.benefit}>
        <Typography variant="h3" className={classes.title}>
          {title}
        </Typography>
        <List dense>
          {benefits.map(benefit => (
            <ListItem className={classes.item}>
              <ListItemIcon className={classes.itemIcon}>
                <Check />
              </ListItemIcon>
              <ListItemText primary={benefit} />
            </ListItem>
          ))}
        </List>
      </Grid>
      <Grid xs={12} md={8} className={classes.content}>
        {Array.isArray(content) ? (
          <ContentItem {...content[contentIndex]} />
        ) : (
          <ContentItem image={content.image} title={content.title} />
        )}
        <footer className={classes.footer}>
          <GradientButton className={classes.btn}>
            <Star />
            <CustomButton className={classes.btnLabel} to="/tiers-list">
              Mejorar Plan para obtenerlo
            </CustomButton>
          </GradientButton>
          {Array.isArray(content) && (
            <IconButton
              className={classes.nextContent}
              onClick={changeContentIndex}
            >
              <ArrowForwardIos />
            </IconButton>
          )}
        </footer>
      </Grid>
    </Grid>
  );
}
